import {OFFSET_COMMON_HEIGHT} from "./constant";

export const calculateDropdownHeight = (className) => {
  const elmt = document.getElementsByClassName(className);
  let height = 0;
  let dropDownMenuHeight = OFFSET_COMMON_HEIGHT * 2;
  if (elmt?.length) {
    height = elmt[0]?.clientHeight;
    const children = elmt[0]?.children;
    const length = elmt[0]?.children?.length;
    let tempHeight = 0;
    if (children?.length) {
      for (let i = 0; i < length; i++) {
        if (i !== length - 1) {
          tempHeight += children[i]?.clientHeight;
        }
      }
      dropDownMenuHeight = height - tempHeight;
      if (dropDownMenuHeight > OFFSET_COMMON_HEIGHT) {
        dropDownMenuHeight -= OFFSET_COMMON_HEIGHT;
      }
    }
  }
  return dropDownMenuHeight;
};
export const idFormatMap = {
  RUT: {
    RUT: "x.xxx.xxx-x",
    8: "x.xxx.xxx-x",
    9: "xx.xxx.xxx-x",
  },
  CPF: "xxx.xxx.xxx-xx",
  CI: {
    CI: "xxx.xxx-x",
    7: "xxx.xxx-x",
    8: "x.xxx.xxx-x",
  },
  DNI: "xx.xxx.xxx",
  AR: {
    AR: "x.xxx.xxx",
    7: "x.xxx.xxx",
    8: "xx.xxx.xxx",
  },
};
export const getFormattedIdForGivenInput = (inputId, idFormat, formatId) => {
  let inputIdPointer = inputId.length - 1;
  let idFormatPointer = idFormat.length - 1;
  let resultStr = "";
  while (inputIdPointer >= 0) {
    if ([".", "-"].includes(idFormat[idFormatPointer]) == true) {
      resultStr = idFormat[idFormatPointer] + resultStr;
      idFormatPointer--;
    } else {
      resultStr = inputId[inputIdPointer] + resultStr;
      inputIdPointer--;
      idFormatPointer--;
    }
  }
  formatId.current = false;
  return resultStr;
};

export const proactiveErrorMapping = {
  PACKAGES_READY_IN_OTHER_STORE: "packageInAnotherStore",
  PACKAGES_WAITING_FOR_LOCATION: "packageWatingForLocation",
  PACKAGES_CANCELLED: "packageCanceled",
  NO_PACKAGES_AVAILABLE: "noPackageAvailable",
};

export const proactiveErrorMessageList = [
  "PACKAGES_READY_IN_OTHER_STORE",
  "PACKAGES_WAITING_FOR_LOCATION",
  "PACKAGES_CANCELLED",
  "NO_PACKAGES_AVAILABLE",
];
